import { render, staticRenderFns } from "./TaskManagementDetail.vue?vue&type=template&id=a36eb5de&scoped=true"
import script from "./TaskManagementDetail.vue?vue&type=script&lang=js"
export * from "./TaskManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskManagementDetail.vue?vue&type=style&index=0&id=a36eb5de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36eb5de",
  null
  
)

export default component.exports